export const CaterApplicationFormModel = {
  id: "",
  eventId: "",
  traderId: "",
  eventApplicationId: "",
  onSiteContact: "",
  onSiteTel: "",
  expectedArrivalDate: null,
  expectedArrivalTime: null,
  staffBuildWristband: null,
  siteVehiclePass: null,
  serviceVehiclePass: null,
  mceWristband: null,
  facilityFee: null,
  adminFee: null,
  powerFee: null,
  litterbondFee: null,
  vat: null,
  processFeePercent: null,
  status: null,
  initialPaymentPer: null,
  payOutDate: null,
  unitId: null,
  traderUnitId: null,
};
